import axios from "axios";
import { captureException } from "../../utils/errorReporting";

export async function uploadFile({
  file,
  onProgress = () => {},
  onError = () => {},
  resourceType = "video",
  params = {}
}) {
  try {
    const encodedFileName = encodeURIComponent(file.name);
    const encodedResourceType = encodeURIComponent(resourceType);
    const extraQuery = Object.entries(params)
      .map(([k, v]) => `&${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join("");
    const response = await axios.get(
      `/get-signed-url?file-name=${encodedFileName}&resource-type=${encodedResourceType}${extraQuery}`
    );
    const { signedRequest, url } = response.data;

    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.upload.onprogress = e => onProgress(getProgress(e));
      xhr.open("PUT", signedRequest);
      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) return;
        if (xhr.status === 200) resolve();
        else
          reject({
            status: xhr.status,
            statusText: xhr.statusText,
            response: xhr.response,
            readyState: xhr.readyState
          });
      };
      xhr.send(file);
    });

    return url;
  } catch (error) {
    console.error("Error uploading file", error);
    onError();
    captureException(error, { boundaryName: "uploadFile" });
    return null;
  }
}

function getProgress(xhrProgressEvent) {
  const { loaded, total } = xhrProgressEvent;
  return ((loaded / total) * 100).toFixed(2);
}

export async function experimental_uploadFileInMultipleParts({ file }) {
  const fileName = file.name;
  const fileType = file.type;

  const res = await axios.post("/create-multipart-upload", { fileName });
  const { uploadId, filePath } = res.data;

  const chunkSize = 64 * 1024 * 1024;
  const numParts = Math.ceil(file.size / chunkSize);
  const parts = [];

  for (let partNumber = 1; partNumber <= numParts; partNumber++) {
    console.log(`Uploading part ${partNumber} of ${numParts}`);
    const start = (partNumber - 1) * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    const blob = file.slice(start, end);

    const presignedUrlResponse = await axios.get("/signed-url-multipart-upload-part", {
      params: {
        "file-path": filePath,
        "upload-id": uploadId,
        "part-number": partNumber
      }
    });
    const presignedUrl = presignedUrlResponse.data.signedRequest;

    const res = await axios.put(presignedUrl, blob, { headers: { "Content-Type": fileType } });

    parts.push({ ETag: res.headers.etag, PartNumber: partNumber });
  }

  await axios.post("/complete-multipart-upload", { filePath, uploadId, parts });

  return filePath;
}
